var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJaneVpsNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "53.005 29.34 92.15 144.995"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(53 25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052CC",
    d: "M6.595 136.16l13.155 13.175L92.155 76.95 19.96 4.34 6.74 17.525l13.01 13.35L6.585 44.04 19.75 57.205.005 76.95 19.75 96.68 6.585 109.845 19.75 123.01z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.245,
    cy: 11.945,
    fill: "#AAD4FF",
    rx: 13.165,
    ry: 8.22,
    transform: "translate(45 65)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiB2aWV3Qm94PSI1My4wMDUwMDEwNjgxMTUyMzQgMjkuMzQwMDAwMTUyNTg3ODkgOTIuMTUwMDAxNTI1ODc4OSAxNDQuOTk1MDEwMzc1OTc2NTYiPgogIDxnIGZpbGw9Im5vbmUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUzIDI1KSI+CiAgICA8cG9seWdvbiBmaWxsPSIjMDA1MkNDIiBwb2ludHM9IjYuNTk1IDEzNi4xNiAxOS43NSAxNDkuMzM1IDkyLjE1NSA3Ni45NSAxOS45NiA0LjM0IDYuNzQgMTcuNTI1IDE5Ljc1IDMwLjg3NSA2LjU4NSA0NC4wNCAxOS43NSA1Ny4yMDUgLjAwNSA3Ni45NSAxOS43NSA5Ni42OCA2LjU4NSAxMDkuODQ1IDE5Ljc1IDEyMy4wMSI+PC9wb2x5Z29uPgogICAgPGVsbGlwc2UgY3g9IjE0LjI0NSIgY3k9IjExLjk0NSIgZmlsbD0iI0FBRDRGRiIgcng9IjEzLjE2NSIgcnk9IjguMjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ1IDY1KSI+PC9lbGxpcHNlPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgJaneVpsNav as ReactComponent };